import React from "react";
import PropTypes from 'prop-types';
import { Typography} from "../../../ecosystem/";

const SelectGroup = ({
    disabled = false,
    handleOnclick = () => ({}),
    label = "Radio",
    name = "radio",
    selected = ""
}) => {
    const checkSelected = label === selected;

    const radioClasses = [
        `bsw-radio`,
        `bsw-radio--${checkSelected ? "selected" : "unselected"}`,
    ].join(' ');

    return (
        <div className={radioClasses}>
            <label className={`radio-container`}>
                <Typography type="body-02">
                    {label}
                </Typography>
                <input
                    type="radio"
                    name={name}
                    value={label}
                    checked={checkSelected}
                    onChange={handleOnclick}
                    disabled={disabled}
                />
                <span className="checkmark" />
            </label>
        </div>
    );
}

SelectGroup.propTypes = {
    disabled: PropTypes.bool,
    name: PropTypes.string,
    label: PropTypes.string,
    selected: PropTypes.string,
    handleOnclick: PropTypes.func
}
export default SelectGroup;